import { createContext } from 'react'

const AppContext = createContext({})

AppContext.displayName = 'AppContext'

export default AppContext
